import React from 'react';
import { motion } from 'framer-motion';
import { Palette, Smartphone, MessageCircle, Target } from 'lucide-react';
export const Benefits: React.FC = () => {
  const benefits = [{
    icon: <Palette className="w-8 h-8" data-id="element-22" />,
    title: 'Diseño profesional',
    description: 'Estética premium que refleja la calidad de tu negocio.'
  }, {
    icon: <Smartphone className="w-8 h-8" data-id="element-23" />,
    title: 'Optimizada para celular',
    description: 'El 80% de tus clientes te visitará desde su móvil. Estarás listo.'
  }, {
    icon: <MessageCircle className="w-8 h-8" data-id="element-24" />,
    title: 'Contacto directo por WhatsApp',
    description: 'Botones estratégicos para que te hablen con un solo clic.'
  }, {
    icon: <Target className="w-8 h-8" data-id="element-25" />,
    title: 'Estructura enfocada en conversión',
    description: 'No solo se ve bien, está diseñada para generar ventas.'
  }];
  return <section id="servicios" className="py-24 relative z-10 bg-dark-surface/30 border-y border-white/5" data-id="element-26">
      <div className="max-w-7xl mx-auto px-6" data-id="element-27">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-28">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-29">
            Webs pensadas para{' '}
            <span className="text-neon-blue text-glow" data-id="element-30">vender</span>, no solo
            para verse lindas.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-31">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-dark-bg border border-white/10 rounded-3xl p-8 hover:border-neon-blue hover:box-glow transition-all duration-300 group" data-id="element-32">
              <div className="w-16 h-16 rounded-2xl bg-dark-surface flex items-center justify-center text-silver group-hover:text-neon-blue group-hover:bg-neon-blue/10 transition-all duration-300 mb-6" data-id="element-33">
                {benefit.icon}
              </div>
              <h3 className="text-2xl font-display font-bold mb-3 text-white" data-id="element-34">
                {benefit.title}
              </h3>
              <p className="text-silver leading-relaxed" data-id="element-35">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};